<template>
  <div class="page-container animate-fade-in-up">
    <PageHeader icon="el-icon-medal" title="成功案例管理" subtitle="管理报告中展示的内部保留案例，支持新增、编辑和删除" />

    <div class="toolbar">
      <el-input v-model="search" placeholder="搜索案例标题" prefix-icon="el-icon-search" clearable style="width: 280px;" />
      <el-button v-if="$hasPermission('case:create')" type="primary" icon="el-icon-plus" class="btn-click" style="margin-left: auto;" @click="openAdd">新增案例</el-button>
    </div>

    <div class="table-wrapper">
      <el-table :data="filteredList" stripe class="data-table">
        <el-table-column prop="case_id" label="ID" width="60" />
        <el-table-column prop="title" label="案例标题" min-width="200" show-overflow-tooltip />
        <el-table-column prop="situation" label="情况" min-width="160" show-overflow-tooltip />
        <el-table-column prop="actions" label="措施" min-width="160" show-overflow-tooltip />
        <el-table-column label="行为标签" width="140">
          <template slot-scope="scope">
            <el-tag v-for="(tag, i) in scope.row.behavior_tags" :key="i" size="mini" style="margin-right: 4px; margin-bottom: 2px;">{{ tag }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="结果" width="100">
          <template slot-scope="scope">
            <span :class="scope.row.result === 1 ? 'result-success' : 'result-fail'">{{ scope.row.result === 1 ? '成功保留' : '未保留' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('case:edit')" type="text" class="action-edit" @click="openEdit(scope.row)">编辑</el-button>
            <el-button v-if="$hasPermission('case:delete')" type="text" class="action-disable" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" :append-to-body="true">
      <el-form label-width="90px">
        <el-form-item label="案例标题"><el-input v-model="form.title" /></el-form-item>
        <el-form-item label="情况描述"><el-input type="textarea" v-model="form.situation" :rows="2" /></el-form-item>
        <el-form-item label="采取措施"><el-input type="textarea" v-model="form.actions" :rows="2" /></el-form-item>
        <el-form-item label="结果描述"><el-input type="textarea" v-model="form.outcome_description" :rows="2" /></el-form-item>
        <el-form-item label="行为标签">
          <el-select
            v-model="form.behavior_tags"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="输入或选择关联行为标签，支持多个"
            style="width: 100%;"
          >
            <el-option v-for="tag in behaviorTags" :key="tag" :label="tag" :value="tag" />
          </el-select>
          <div class="form-hint">支持手工输入新标签，回车即可添加</div>
        </el-form-item>
        <el-form-item label="保留结果">
          <el-radio-group v-model="form.result">
            <el-radio :label="1">成功保留</el-radio>
            <el-radio :label="0">未保留</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="内部案例">
          <el-checkbox v-model="form.is_internal">公司内部案例</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '../../components/PageHeader.vue'

export default {
  name: 'CaseManage',
  components: { PageHeader },
  data() {
    return {
      search: '',
      dialogVisible: false,
      isEdit: false,
      form: { case_id: null, title: '', situation: '', actions: '', outcome_description: '', behavior_tags: [], result: 1, is_internal: 1 },
      behaviorTags: ['被忽视', '无发展', '薪资偏低', '工作量大', '沟通少', '外部机会', '绩效下滑', '频繁请假']
    }
  },
  computed: {
    list() {
      const taskId = this.$store.getters.currentTaskId
      const all = this.$store.state.cases.cases || []
      if (!taskId) return all
      return all.filter(c => c.task_id === taskId || !c.task_id)
    },
    filteredList() {
      if (!this.search) return this.list
      const k = this.search.toLowerCase()
      return this.list.filter(c => c.title.toLowerCase().includes(k) || c.situation.toLowerCase().includes(k))
    },
    dialogTitle() { return this.isEdit ? '编辑案例' : '新增案例' }
  },
  methods: {
    openAdd() {
      this.isEdit = false
      this.form = { case_id: null, title: '', situation: '', actions: '', outcome_description: '', behavior_tags: [], result: 1, is_internal: 1 }
      this.dialogVisible = true
    },
    openEdit(row) {
      this.isEdit = true
      this.form = { ...row, behavior_tags: row.behavior_tags ? [...row.behavior_tags] : [] }
      this.dialogVisible = true
    },
    save() {
      const payload = { ...this.form, is_internal: this.form.is_internal ? 1 : 0 }
      if (this.isEdit) {
        this.$store.commit('cases/UPDATE_CASE', payload)
        this.$message.success('已更新')
      } else {
        payload.case_id = Date.now()
        this.$store.commit('cases/ADD_CASE', payload)
        this.$message.success('已新增')
      }
      this.dialogVisible = false
    },
    remove(row) {
      this.$confirm('确定删除案例「' + row.title + '」？', '提示', { type: 'warning' }).then(() => {
        this.$store.commit('cases/DELETE_CASE', row.case_id)
        this.$message.success('已删除')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; align-items: center; margin-bottom: var(--space-lg); }
.table-wrapper { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: var(--radius-lg); overflow: hidden; box-shadow: var(--shadow-sm); }
.data-table >>> th { background: var(--color-bg) !important; color: var(--color-text) !important; font-weight: 600 !important; }
.action-edit { color: var(--color-primary) !important; }
.action-disable { color: var(--color-high) !important; }
.result-success { color: var(--color-low); font-weight: 600; }
.result-fail { color: var(--color-high); font-weight: 600; }
</style>
